import { memo } from 'react';
import { Text, Tooltip } from '@optiaxiom/react';

import * as styles from './NodeDescription.css';

type NodeDescriptionProps = {
  description: string;
  lineClamp?: string;
};

export const NodeDescription = memo(({ description, lineClamp = '2' }: NodeDescriptionProps) => {
  if (!description) return null;

  return (
    <Tooltip content={description}>
      <Text lineClamp={lineClamp} className={styles.nodeDescription}>
        {description}
      </Text>
    </Tooltip>
  );
});

NodeDescription.displayName = 'NodeDescription';
